import React, { FC } from 'react';
import useTranslation from '../../../hooks/useTranslation';
import CapacityFormOutboundFields from '../CapacityFormOutboundFields';
import CustomSelect from '../../../common/CustomSelect';
import InlineMessage from '@ingka/inline-message';

const CloseCapacityForm: FC = () => {
  const t = useTranslation();

  return (
    <>
      <InlineMessage
        body={t('flight.createSubmissionModal.capacity_info')}
        variant={'cautionary'}
      />
      <CapacityFormOutboundFields />

      <CustomSelect
        dataTestID={'astroDecommissioning-select'}
        optionsArray={{ YES: t('common.yes'), NO: t('common.no') }}
        name={'needForAstroDecommissioning'}
        defaultValue={'NO'}
        label={t('labels.astroDecommissioning')}
        required={true}
      />
    </>
  );
};

export default CloseCapacityForm;
